import * as React from "react"
import type { SVGProps } from "react"
const SvgDesign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m8.8 10.95 2.15-2.17-1.4-1.43-.4.4a1 1 0 0 1-.69.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.3-.71q0-.42.3-.72l.38-.37L7 4.83 4.83 7zm8.2 8.23L19.18 17l-1.13-1.12-.4.37q-.3.3-.7.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7q0-.4.3-.7l.38-.4-1.43-1.4-2.15 2.15zM4 21a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20v-2.82q0-.2.08-.4a1 1 0 0 1 .22-.33l4.08-4.07-4.33-4.33A1.4 1.4 0 0 1 2.63 7q0-.63.42-1.05l2.9-2.9q.42-.42 1.05-.41a1.5 1.5 0 0 1 1.05.44L12.4 7.4l3.78-3.8a2 2 0 0 1 .67-.45 2 2 0 0 1 1.55 0 2 2 0 0 1 .68.45l1.32 1.35A2 2 0 0 1 21 6.4a2 2 0 0 1-.6 1.43l-3.78 3.8 4.33 4.32q.42.42.42 1.05t-.42 1.05l-2.9 2.9a1.4 1.4 0 0 1-1.05.43q-.63 0-1.05-.43l-4.33-4.32-4.07 4.07a1 1 0 0 1-.72.3zm1-2h1.4l9.8-9.77-1.42-1.43L5 17.6z" />
  </svg>
)
export default SvgDesign
